"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PayableEntity;
(function (PayableEntity) {
    PayableEntity["ApplePay"] = "applebtn";
    PayableEntity["GooglePay"] = "googlebtn";
    PayableEntity["Form"] = "form";
    PayableEntity["Resign"] = "resign";
    PayableEntity["Paypal"] = "paypal";
})(PayableEntity || (PayableEntity = {}));
exports.default = PayableEntity;
